import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { CONTACT_INFO } from "../../config/constants";

export default function ContactUsLeftColumn(){

    const address = CONTACT_INFO.address;
    const email = CONTACT_INFO.email;
    const phone = CONTACT_INFO.mainPhone;
    const phone2 = CONTACT_INFO.phone2;
    const phone3 = CONTACT_INFO.phone3;
    const phone4 = CONTACT_INFO.phone4;

    return(
        <div>
            <div className="bg-sky-600 transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-102 hover:bg-sky-700 rounded-xl shadow-xl text-white p-4 md:p-8 mb-8 relative overflow-hidden">
                <div className="mb-6">
                    <h2 className="text-2xl md:text-lg font-bold mb-2 font-heading tracking-wide">Address :</h2>
                    <h2 className="text-2xl md:text-lg font-bold mb-2 font-heading tracking-wide">Madeshwara Ambulance Service</h2>
                    <p className="mb-4 text-sm md:text-base text-sky-100 tracking-wide">
                        {address}
                    </p>
                    <h3 className="font-bold mb-1 text-lg">Call Us :</h3>
                    <ul className="text-sm space-y-2">
                        <li className="flex items-center gap-2 tracking-widest whitespace-nowrap">
                          <FaPhoneAlt className="text-white text-sm" />
                          +91 {phone}
                        </li>
                        <li className="flex items-center gap-2 tracking-widest whitespace-nowrap">
                          <FaPhoneAlt className="text-white text-sm" />
                          +91 {phone2}
                        </li>
                        <li className="flex items-center gap-2 tracking-widest whitespace-nowrap">
                          <FaPhoneAlt className="text-white text-sm" />
                          +91 {phone3}
                        </li>
                        <li className="flex items-center gap-2 tracking-widest whitespace-nowrap">
                          <FaPhoneAlt className="text-white text-sm" />
                          +91 {phone4}
                        </li>
                    </ul>
                    <h3 className="font-bold mt-4 mb-1 text-lg">Email :</h3>
                    <a href="mailto:contact@mahadeswaraambulance.com" className="text-sky-200 underline break-words select-text">
                        {email}
                    </a>
                </div>
            </div>
            <div className="bg-white border border-sky-600 rounded-xl shadow-xl p-2 overflow-hidden aspect-video">
                <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.586986558853!2d77.59020937364285!3d12.934245787689914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15acdf10a099%3A0x6f3af780c359e336!2sMadeshwara%20Ambulance%20Services!5e0!3m2!1sen!2sin!4v1758289338301!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    alt="Google Map location"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </div>
    )
}